<template>
    <Head title="Applicant Training"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Manage Pengajuan Lembur</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                    ></Column>
                    <Column
                        field="user.name"
                        header="Nama Karyawan"
                        :sortable="true"
                        headerStyle="width:50%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Nama Karyawan</span>
                            {{ slotProps.data.user.name }}
                        </template>
                    </Column>
                    <Column
                        field="tanggal"
                        header="Tanggal"
                        :sortable="true"
                        headerStyle="width:50%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Tanggal</span>
                            {{ slotProps.data.tanggal.value }}
                        </template>
                    </Column>
                    <Column
                        field="status"
                        header="Status"
                        :sortable="true"
                        headerStyle="width:50%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Status</span>
                            {{ slotProps.data.status.value }}
                        </template>
                    </Column>
                    <Column headerStyle="width:50%;">
                        <template #body="slotProps">
                            <div v-if="slotProps.data.status.as == 'filed'" class="flex gap-2">
                                <Button
                                    icon="pi pi-check"
                                    class="p-button-rounded p-button-success mr-2"
                                    @click="approveDialog(slotProps.data)"
                                />
                                <Button
                                    icon="pi pi-times"
                                    class="p-button-rounded p-button-danger mr-2"
                                    @click="rejectedDialog(slotProps.data)"
                                />
                                <Button
                                    icon="pi pi-eye"
                                    class="p-button-rounded p-button-primary mr-2"
                                    @click="detailDialog(slotProps.data)"
                                />
                            </div>
                            <div v-else-if="slotProps.data.status.as === 'approved'" class="flex gap-2">
                                <Button
                                    icon="pi pi-camera"
                                    class="p-button-rounded p-button-success mr-2"
                                    @click="presentDialog(slotProps.data)"
                                />
                                <Button
                                    icon="pi pi-eye"
                                    class="p-button-rounded p-button-primary mr-2"
                                    @click="detailDialog(slotProps.data)"
                                />
                            </div>
                            <div v-else-if="slotProps.data.status.as === 'present'" class="flex gap-2">
                                <Button
                                    icon="pi pi-sign-out"
                                    class="p-button-rounded p-button-success mr-2"
                                    @click="leaveDialog(slotProps.data)"
                                />
                                <Button
                                    icon="pi pi-eye"
                                    class="p-button-rounded p-button-primary mr-2"
                                    @click="detailDialog(slotProps.data)"
                                />
                            </div>
                            <div v-else class="flex gap-2">
                                <Button
                                    icon="pi pi-eye"
                                    class="p-button-rounded p-button-primary mr-2"
                                    @click="detailDialog(slotProps.data)"
                                />
                            </div>
                        </template>
                    </Column>
                </DataTable>

                <Dialog
                    v-model:visible="detailModelDialog"
                    :style="{ width: '450px' }"
                    header="Detail Overtime"
                    :modal="true"
                >
                    <div class="flex flex-wrap w-full align-items-center justify-content-center">
                        <div class="col-6 bg-gray-300">Name</div>
                        <div class="col-6">{{ model.user.name }}</div>
                        <div class="col-6 bg-gray-300">Tanggal</div>
                        <div class="col-6">{{ model.tanggal.value }}</div>
                        <div class="col-6 bg-gray-300">Total Lembur</div>
                        <div class="col-6">{{ model.total_lembur }}</div>
                        <div class="col-6 bg-gray-300">Jam Masuk</div>
                        <div class="col-6">{{ model.jam_masuk.value }}</div>
                        <div class="col-6 bg-gray-300">Jam Keluar</div>
                        <div class="col-6">{{ model.jam_keluar.value }}</div>
                        <div class="col-6 bg-gray-300">Status</div>
                        <div class="col-6">{{ model.status.value }}</div>
                    </div>
                    <template #footer>
                        <Button
                            label="Close"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="detailModelDialog = false"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="approveModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to approve ?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="approveModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="approveModel(true)"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="rejectedModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to rejected ?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="rejectedModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="approveModel(false)"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="presentModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to present ?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="presentModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="presentModel('present')"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="leaveModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to present ?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="leaveModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="presentModel('leave')"
                        />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head } from "@inertiajs/inertia-vue3";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import Textarea from "primevue/textarea";
import Badge from "primevue/badge";
import Dialog from "primevue/dialog";
import DatatableService from "../../Services/DatatableService";
import axios from "axios";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        Button,
        InputText,
        Toolbar,
        Toast,
        DataTable,
        Column,
        Dropdown,
        Dialog,
        Badge,
        Calendar,
        Textarea
    },
    data() {
        return {
            // Data with type data object
            filters: {},
            lazyParams: {},
            model: {},
            badgeColor: {
                'waiting': 'warning',
                'success': 'success',
                'failed': 'danger'
            },
            status: {
                'holiday': 'pi pi-star text-yellow-600',
                'present': 'pi pi-check text-green-600',
                'absent': 'pi pi-times text-red-600',
                'unshift': 'pi pi-ban text-red-800',
            },
            userDetail: JSON.parse(sessionStorage.getItem('auth:me')) ?? [],
            // Data with type data string
            searchFilter: "",
            // data with type data boolean
            loading: true,
            submitted: false,
            selectAll: false,
            isExporting: false,
            // data with type data numeric
            totalRecords: 0,
            date: 0,
            // data with type data any
            selectedModel: null,
            selectedModels: null,
            models: null,
            // model dialog
            approveModelDialog: false,
            rejectedModelDialog: false,
            presentModelDialog: false,
            leaveModelDialog: false,
            detailModelDialog: false,
            // selected
            selectedModels: null,
            submitted: false,
            selectAll: false,
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
        let date = new Date();
        this.currentDate(date.getFullYear(), date.getMonth())
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };
        this.loadLazyData();
    },
    methods: {
        // Get API
        loadLazyData() {
            this.loading = true;
            this.lazyParams = {
                ...this.lazyParams,
                where: {
                    'user_id': this.userDetail.id,
                }
            }
            this.datatableService
                .getData(this.route("api.overtime.getdata"), this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        // Page Action
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        hideDialog() {
            this.approveModelDialog = false;
            this.rejectedModelDialog = false;
            this.presentModelDialog = false,
            this.successModelDialog = false,
            this.detailModelDialog = false,
            this.model = {};
        },
        // Action methods
        // approve models dialog
        approveDialog(model) {
            this.approveModelDialog = true;
            this.model = model
        },
        rejectedDialog(model) {
            this.rejectedModelDialog = true;
            this.model = model
        },
        presentDialog(model) {
            this.presentModelDialog = true;
            this.model = model
        },
        leaveDialog(model) {
            this.leaveModelDialog = true;
            this.model = model
        },
        detailDialog(model) {
            this.detailModelDialog = true;
            this.model = model
        },
        approveModel(approved) {
            axios.get(this.route(`api.overtime.approval`, this.model.id)+`?user=${this.userDetail.id}&approved=${approved ? 1 : 0}`)
            .then(() => {
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Overtime Success " + approved ? 'approved' : 'rejected',
                    life: 3000,
                });
                this.hideDialog()
                this.loadLazyData();
            })
            .catch((err) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Overtime failed " + approved ? 'approved' : 'rejected',
                    life: 3000,
                });
                this.hideDialog()
            })
        },
        presentModel(present) {
            document.location.href = this.route('overtime.user.attendance', this.model.id)+`?attendance=${present}`;
        },
        // Initiation Filter
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS, field: 'user.name' },
            };
        },
        // Current Date
        currentDate(year, month) {
            this.date = new Date(year, month, 0).getDate();
        }
    },
};
</script>
<style scoped lang="scss">
@import "../../../assets/demo/badges.scss";
</style>
